import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import { KcButtonComponent, KcIconComponent } from '@kaspacom/ui-kit';
import { WalletManager } from '../../managers/wallet.manager';
import { WalletTypeEnum } from '../../models/enums/wallet-type.enum';
import { TruncateWalletAddressPipe } from '../../pipes/truncate-wallet-address.pipe';
import { KcWalletAvatarComponent } from '../defi-wallet-avatar/defi-wallet-avatar.component';
import { KaspaComWebWalletService } from '../../services/wallets/kaspa-com-web-wallet.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'kcc20-wallet-chip',
  standalone: true,
  imports: [
    KcButtonComponent,
    KcIconComponent,
    KcWalletAvatarComponent,
    TruncateWalletAddressPipe,
  ],
  templateUrl: './wallet-chip.component.html',
  styleUrl: './wallet-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletChipComponent {
  protected readonly walletManager = inject(WalletManager);
  private readonly kaspaComWalletService = inject(KaspaComWebWalletService);
  protected readonly themeService = inject(ThemeService);

  protected readonly dropdownOpen = signal(false);
  protected readonly copied = signal(false);
  protected readonly kaspaComWalletType = WalletTypeEnum.KASPA_COM_WEB_WALLET;
  readonly compact = input<boolean>(false);

  protected toggleDropdown(): void {
    this.dropdownOpen.update((v) => !v);
  }

  protected closeDropdown(): void {
    this.dropdownOpen.set(false);
  }

  protected connect(): void {
    this.walletManager.requestLoginModal();
  }

  protected copyAddress(address: string): void {
    if (!navigator.clipboard) return;
    navigator.clipboard
      .writeText(address)
      .then(() => {
        this.copied.set(true);
        setTimeout(() => this.copied.set(false), 1500);
      })
      .catch(() => {});
  }

  protected openWallet(): void {
    void this.kaspaComWalletService.setShowWallet(true, true);
    this.closeDropdown();
  }

  protected disconnect(): void {
    void this.walletManager.disconnect();
    this.closeDropdown();
  }

  protected toggleTheme(): void {
    this.themeService.toggle();
  }
}
